import { render, staticRenderFns } from "./WeeklyConsumptionPanel.vue?vue&type=template&id=29d6b8c0&"
import script from "./WeeklyConsumptionPanel.vue?vue&type=script&lang=ts&"
export * from "./WeeklyConsumptionPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports